module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(szablon)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.templates.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do szablonów")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edytuj szablon")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Kod szablonu\n              ")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.item.code))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Typ szablonu\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.template_type == 'html' ? 'Html' : 'Tekstowy') + "\n              ")])])])]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Treść szablonu\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "template-pre"
  }, [_vm._v("\n          " + _vm._s(_vm.item.body) + "\n      ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f3b2f0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/Show.vue
// module id = 239
// module chunks = 0